export default __webpack_public_path__ + "static/media/other_color.4ce8d9fa.svg";